import { PredictDiffSign } from "./predict-diff-sign.model";

export class GoodsForCheckPlanNumModel {
  constructor(
    public orderCode = '',
    public mediumType = '',
    public checkFlag = false,
    public predictPlanNum = '',
    public planNum = '',
    public predictDiff: { absValue: string, sign: PredictDiffSign; }
      = { absValue: '', sign: PredictDiffSign.Zero },
    public supplyPrice = '',
    public feature = { code: '', label: '' },
    public pCode = '',
    public goodsGuideName = '',
    public goodsStandardName = '',
    public pricePattern = '',
    public pricePromotion = { code: '', label: '' },
    public appearDiv = { code: '', label: '' },
    public komaPromotion = { code: '', label: '' },
    public promotionMark = { code: '', label: '' },
    public thisTimeSupplyPrice = '',
    public thisTimeCostPrice = ''
  ) { }
}
